// extracted by mini-css-extract-plugin
export default {"closeButton":"style_closeButton__BSfao","toastContainer":"style_toastContainer__wqf9h"};